<template>
  <div class="svg">
    <img v-if="image.length" :src="image" />
  </div>
</template>

<script type="text/javascript">
export default {
  data () {
    return {
      image: ''
    };
  },
  props: ['type'],
  mounted () {
    this.image = require(`@/assets/images/${this.type}.svg`)
  }
};
</script>

<style lang="less">
.svg {
  img {
    width: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/spinner.vue